import React from 'react';
import { connect } from 'react-redux';
import Immutable from 'immutable';

import { resultsConfigSelector, describedProductsSelector } from 'ctm-selectors';

import { ProductCompare } from './product_compare';
import { ProductCompareIcon } from './product_compare_icon/product_compare_icon';

const _ProductCompareContainer = (props) => <ProductCompare {...props} />;
const _ProductCompareIconContainer = (props) => <ProductCompareIcon {...props} />;

/**
 * Extract the following data from the store:
 * - Products that have been selected.
 * - If user has chosen to compare the selected products.
 * @param {Object} state - Redux store state.
 * @param {Object} props - Props passed to the component.
 * @return {Object} - The state attrs to add to props.
 */
export const mapStateToProps = (state, props) => {
    const resultsConfig = resultsConfigSelector(state);
    const selectedProductIds = resultsConfig.getIn(['helpers', 'filters', 'selectedProductIds']) || Immutable.List();
    const compareModeActive = resultsConfig.get('compareModeActive') || false;
    const frequency = resultsConfig.getIn(['filters', 'frequency']);
    const minProducts = resultsConfig.get('minProducts') || 2;

    const products = selectedProductIds.map((selectedProductId) => {
        return describedProductsSelector(state).find((x) => x.getIn(['productMeta', 'id']) === selectedProductId);
    });

    return {
        ...props,
        minProducts,
        selectedProductIds,
        compareModeActive,
        frequency,
        products
    };
};

/**
 * Create functions to enable user to select/deselect products and toggle between compare mode.
 * @param {Function} dispatch - Redux dispatch method.
 * @param {Object} props - Props passed to the component.
 * @return {Object} - Function to dispatch actions that are passed as props.
 */
export const mapDispatchToProps = (dispatch, props) => ({
    toggleCompare: (toggle) => {
        dispatch({ type: 'TOGGLE_COMPARE_MODE', toggle });
    },
    removeProduct: (productId) => {
        dispatch({
            type: 'TOGGLE_COMPARED_PRODUCT',
            toggle: false,
            filterValue: productId
        });
    }
});
const ProductCompareContainer = connect(mapStateToProps, mapDispatchToProps)(_ProductCompareContainer);
const ProductCompareIconContainer = connect(mapStateToProps, mapDispatchToProps)(_ProductCompareIconContainer);

export {
    ProductCompareContainer,
    ProductCompareIconContainer,
    _ProductCompareContainer,
    _ProductCompareIconContainer
};
